import { styled } from "@mui/material/styles";

export const NavBar = styled("div")(({ theme }) => ({
  display: "flex",
  background: "#ebebeb",
  height: "100px",
  alignItems: "center"
}));

export const Logo = styled("div")(({ theme }) => ({
  flex: 1,
  width: "200px",
  margin: "5px 0"
}));

export const NavItems = styled("ul")(({ theme }) => ({
  listStyle: "none",
  flex: 1,
  display: "flex",
  height: "30px"
}));

export const NavItem = styled("li")(({ theme }) => ({
  margin: "0 10px",

  "& a": {
    color: "#3874cb",
    textDecoration: "none",
    fontWeight: "bold"
  },

  "&.selected": {
    borderBottom: "2px solid #3874cb"
  }
}));

export const UserMenu = styled("div")(({ theme }) => ({
  flex: 1
}));

export default { NavBar, Logo, NavItems, NavItem, UserMenu };
